const mainView = require('./views/main');
const validateView = require('./views/validate');

module.exports = {
  '/': mainView,
  '/verify': validateView,
};
